const ACCESS_KEY = "access_token";
const EXPIRES_AT_KEY = "token_expires_at"; // unix ms

export const tokenStore = {
  get() {
    const token = localStorage.getItem(ACCESS_KEY);
    const exp = Number(localStorage.getItem(EXPIRES_AT_KEY) || 0);
    return { token, exp };
  },
  set(token: string, expUnixMs: number) {
    localStorage.setItem(ACCESS_KEY, token);
    localStorage.setItem(EXPIRES_AT_KEY, String(expUnixMs));
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(EXPIRES_AT_KEY);
  },
  isExpired(graceMs = 0) {
    const { exp } = tokenStore.get();
    return !exp || Date.now() + graceMs >= exp;
  },
};
